import { render } from "./newsLetter.vue?vue&type=template&id=46bd4283"
import script from "./newsLetter.vue?vue&type=script&lang=js"
export * from "./newsLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__